<template>
   <b-card class="sme-dashboard-card">
      <div class="d-flex align-items-center justify-content-between">
         <div class="d-flex align-items-center section-title">
            <span class="progress-card-title">{{ title }}</span>
         </div>
         <div class="d-flex align-items-center">
            <span :id="`${ident}-percentage`" class="mr-2 progress-card-percentage">
               {{ progress || 0 }}% Complete
            </span>
            <b-progress
               :value="progress"
               :max="100"
               class="section-progress"
               :variant="isComplete ? 'success' : 'primary'"
            >
            </b-progress>
            <b-button
               id="btn-profile"
               variant="success"
               size="sm"
               :class="{invisible: !actionButtonVisible}"
               class="ml-3 action-button"
               :to="actionButtonLink"
               style="font-size: 0.75rem"
            >
               Go
            </b-button>
         </div>
      </div>
   </b-card>
</template>

<script>
export default {
   props: {
      ident: {
         type: String,
      },

      title: {
         type: String,
      },

      progress: {
         type: Number,
      },

      actionButtonLink: {
         type: Object,
      },

      actionButtonVisible: {
         type: Boolean,
         default: true,
      },
   },

   computed: {
      isComplete() {
         return this.progress === 100;
      },
   },
};
</script>

<style lang="scss" scoped>
.sme-dashboard-card {
   margin-bottom: 0;
}

.progress-card-title {
   font-size: 0.8125rem;
   font-weight: 700;
}

.progress-card-percentage {
   font-size: 0.8125rem;
}

::v-deep .text-table-field {
   font-size: 0.8125rem;
}

.action-button {
   font-size: 0.75rem;
}

.section-title {
   @include lg-max {
      font-size: 1.25rem;
   }
}

.section-progress {
   min-width: 7rem;
   @include lg {
      min-width: 14rem;
   }
}
</style>
